
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/reddit-ads",
      function () {
        return require("private-next-pages/destinations/reddit-ads.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/reddit-ads"])
      });
    }
  